import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addNewJob, editJob, getJobById, getJobs, removeJob } from "./jobsApi";

const initialState = {
  jobs: [],
  isLoading: false,
  error: "",
  isError: false,
  job: {},
  query: "",
};

export const fetchJobs = createAsyncThunk("jobs/fetchJobs", async (type) => {
  const response = await getJobs(type);
  return response;
});

export const fetchJobById = createAsyncThunk(
  "jobs/fetchJobById",
  async (id) => {
    const response = await getJobById(id);
    return response;
  }
);

export const updateJob = createAsyncThunk("jobs/updateJob", async (job) => {
  const response = await editJob(job);
  return response;
});

export const addJob = createAsyncThunk("jobs/addJob", async (job) => {
  const response = await addNewJob(job);
  return response;
});

export const deleteJob = createAsyncThunk("jobs/deleteJob", async (id) => {
  const response = await removeJob(id);
  return response;
});

// update jobs array but its not necessary because we are fetching jobs again after update and add new job
export const filterJobs = createAsyncThunk(
  "jobs/filterJobs",
  async (filter) => {
    const response = await getJobs();
    return response;
  }
);
const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    searchJobs: (state, action) => {
      state.query = action.payload;
    },
    sortJobs: (state, action) => {
      if (action.payload === "default") {
        state.jobs = state.jobs.sort((a, b) => a.id - b.id);
      } else if (action.payload === "lowtohigh") {
        state.jobs = state.jobs.sort((a, b) => a.salary - b.salary);
      } else if (action.payload === "hightolow") {
        state.jobs = state.jobs.sort((a, b) => b.salary - a.salary);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchJobById.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
        state.job = {};
      })
      .addCase(fetchJobById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.job = action.payload;
      })
      .addCase(fetchJobById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(updateJob.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
        state.job = {};
      })
      .addCase(updateJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.job = action.payload;
        state.jobs = state.jobs.map((job) =>
          job.id === action.payload.id ? action.payload : job
        );
      })
      .addCase(updateJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(addJob.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(addJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = [...state.jobs, action.payload];
        // state.isSuccess = true;
      })
      .addCase(addJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(deleteJob.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(deleteJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = state.jobs.filter((job) => job.id !== action.meta.arg);
      })
      .addCase(deleteJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { searchJobs, sortJobs } = jobSlice.actions;

export default jobSlice.reducer;
